import { object, boolean, number, string, date, InferType, ObjectSchema } from 'yup';
import { AprovarOrcamentoContract } from '../contracts/aprovar-orcamento.contracts';

export const aprovarOrcamentoSchema: ObjectSchema<AprovarOrcamentoContract> = object({
    isToWorkflow: boolean().required('Obrigatório informar se vai para workflow'),
    startDate: date()
        .when('isToWorkflow', {
            is: true,
            then: schema => schema.required('É obrigatório informar a data de início da obra para aprovar o orçamento!'),
            otherwise: schema => schema.notRequired(),
        }),
    endDate: date()
        .when('isToWorkflow', {
            is: true,
            then: schema => schema.required('É obrigatório informar a data de término da obra para aprovar o orçamento!'),
            otherwise: schema => schema.notRequired(),
        }),
        createAccountsReceivable: boolean()
            .when('isToWorkflow', {
                is: true,
                then: schema => schema.required('Obrigatório informar se irá criar contas a receber'),
                otherwise: schema => schema.notRequired(),
            }),
        isDownPaymentValue: boolean()
            .when('isToWorkflow', {
                is: true,
                then: schema => schema.required('Obrigatório informar se há valor de entrada'),
                otherwise: schema => schema.notRequired(),
            }),
    downPaymentValue: number()
        .transform((value, originalValue) => {
            if (typeof originalValue === "string") {
                let cleaned = originalValue.replace(/[^\d,]/g, "");

                const lastComma = cleaned.lastIndexOf(",");
                if (lastComma !== -1) {
                    cleaned =
                        cleaned.slice(0, lastComma).replace(/,/g, "") +
                        "." +
                        cleaned.slice(lastComma + 1);
                }

                if (!cleaned) return undefined;

                const valorNumber = Number(cleaned);
                return isNaN(valorNumber) ? undefined : valorNumber;
            }

            return value;
        })
            .when(['isToWorkflow', 'createAccountsReceivable', 'isDownPaymentValue'], {
                is: (isToWorkflow: boolean, createAccountsReceivable: boolean, isDownPaymentValue: boolean) =>
                    isToWorkflow && createAccountsReceivable && isDownPaymentValue,
                then: schema => schema
                    .typeError('Valor inválido!')
                    .required('É obrigatório informar o valor da entrada para aprovar o orçamento!')
                    .min(1, 'O valor da entrada deve ser maior que zero!'),
                otherwise: schema => schema.nullable().notRequired(),
            }),
    installmentCount: number()
        .when('createAccountsReceivable', {
            is: true,
            then: schema => schema.required('É obrigatório informar a quantidade de parcelas para aprovar o orçamento!').min(1, 'A quantidade de parcelas deve ser maior que zero!'),
            otherwise: schema => schema.notRequired(),
        }),
    dueDate: date()
        .when('createAccountsReceivable', {
            is: true,
            then: schema => schema.required('É obrigatório informar a data de vencimento para aprovar o orçamento!'),
            otherwise: schema => schema.notRequired(),
        }),
    idSector: string()
        .when('createAccountsReceivable', {
            is: true,
            then: schema => schema.required('Informe um setor de origem'),
            otherwise: schema => schema.notRequired(),
        }),
    chartOfAccountsId: string()
        .when('createAccountsReceivable', {
            is: true,
            then: schema => schema.required('Informe um plano de contas'),
            otherwise: schema => schema.notRequired(),
        }),
});

export type AprovarOrcamentoFormData = InferType<typeof aprovarOrcamentoSchema>;
